import { logSentry } from '@gto/sentry'

/**
 * Shared boundary coercion for affiliate commission RATES (percentages). The
 * affiliate BE serialises Decimal `commission_rate` and per-partner override
 * fields as STRINGS on the wire (e.g. "15.00"); call sites need real `number`s
 * for math (`/100`) and percent formatters. A non-numeric/NaN input is a BE
 * contract violation — render 0 rather than crash `FormattedNumber` / `${...}%`
 * concatenations, but page the breach via `logSentry` so a silent 0% rate
 * does NOT pass as truth (a 0% effective rate is a trap operators rely on).
 *
 * Mirror of `to-amount.ts` (which is for money). Kept distinct so the Sentry
 * grep distinguishes a money-shaped breach from a rate-shaped one — and so a
 * future range check (e.g. assert 0..100) only lives in the rate helper.
 *
 * `logPrefix` identifies the surface (e.g. `'tiers toRate:'`,
 * `'partner-detail effective_rate:'`) so consumers can attribute reports.
 */
export const toRate = (value: number | string | null | undefined, logPrefix: string): number => {
  if (value == null) {
    return 0
  }
  const n = Number(value)

  if (!Number.isFinite(n)) {
    logSentry(logPrefix, { value })

    return 0
  }

  return n
}
